import type {ReactElement} from 'react';
import React from 'react';
import {getRegistrationButtonTextOptions, registerTextDropdownID} from '@Components/event-wizard/event-wizard-registrations/event-wizard-registrations.types';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItem3} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {getEventWizardRegistrationButtonText} from '@Components/event-wizard/event-wizard.hooks';
import type {EventWizardRegistrationsButtonTextDropdownContentProps} from './event-wizard-registrations-button-text-dropdown-content.types';
import styles from './event-wizard-registrations-button-text-dropdown-content.module.scss';
import {useAppSelector} from '@/hooks';

export function EventWizardRegistrationsButtonTextDropdownContent({onClickOption}: EventWizardRegistrationsButtonTextDropdownContentProps): ReactElement {
  const getContentItems = (): Array<ControlledListItem3> => {
    const selectedRegistrationButtonText = useAppSelector(getEventWizardRegistrationButtonText);

    return getRegistrationButtonTextOptions().map((registerText: string, index: number) => {
      const isSelected = registerText === selectedRegistrationButtonText;
      return {
        id: `${index}_${registerText}`,
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_3,
        text: registerText,
        className: styles.listItem,
        isSelected,
        onClick(): void {
          onClickOption(registerText);
        },
      };
    });
  };

  return <ControlledList id={registerTextDropdownID} items={getContentItems()} />;
}
